import React from "react";
import { Link, useLocation } from "react-router-dom";
import Header from "./../component/Header";
import Footer from "./../component/Footer";
import { useLanguage } from "../context/LanguageContext";

const PaymentFailed = () => {
    const { langJson } = useLanguage();
    const location = useLocation();
    const message = location?.state?.message;

    return (
        <div>
            <Header />
            <style>{`body { background: #F5F7FA; }`}</style>

            <div className="mainDiv">
                <div className="orderDiv">
                    <h2>{langJson?.paymentfailed || "Payment failed"}</h2>
                    <p>{message || langJson?.yourpaymentcouldnotbecompleted || "Your payment could not be completed."}</p>
                    <div className="orderBtns">
                        <Link to="/payment" className="myOrderBtn">
                            {langJson?.tryagain || "Try again"}
                        </Link>
                        <Link to="/cart" className="contBtn">
                            {langJson?.backtocart || "Back to cart"}
                        </Link>
                    </div>
                </div>

                <Footer />
            </div>
        </div>
    );
};

export default PaymentFailed;
